import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  Skeleton,
} from "@mui/material";

const useBreakpoints = () => {
  const theme = useTheme();
  return {
    isXs: useMediaQuery(theme.breakpoints.only("xs")),
    isSm: useMediaQuery(theme.breakpoints.only("sm")),
    isDownSm: useMediaQuery(theme.breakpoints.down("sm")),
  };
};

export const PageContainer = (props) => (
  <Container
    {...props}
    sx={{
      height: "100%",
      display: "flex",
      flexDirection: "column",
      padding: 2,
      alignItems: "center",
    }}
  />
);

export const ErrorCard = ({
  title = "Something went wrong",
  message = "An unexpected error occurred. Please try again.",
  onRetry = () => {},
  isFetching = false,
}) => {
  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid item xs={10} sm={9} md={8} lg={6}>
        <Card
          sx={{
            mt: { xs: 3, sm: 10, md: 15 },
            px: 2,
            py: 3,
            textAlign: "center",
          }}
        >
          <CardContent>
            <Typography variant="h6" gutterBottom>
              {title}
            </Typography>
            {message && (
              <Typography variant="body2" gutterBottom>
                {message}
              </Typography>
            )}
            {onRetry && (
              <Button
                variant="outlined"
                color="secondary"
                onClick={onRetry}
                disabled={isFetching}
                sx={{ mt: 2, width: 120 }}
              >
                {isFetching ? "Retrying..." : "Retry"}
              </Button>
            )}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export const ContentSkeleton = () => {
  const { isDownSm } = useBreakpoints();
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100%"
      width="100%"
      gap={isDownSm ? 1.5 : 3}
    >
      <Skeleton variant="rectangular" width="100%" height="100%" />
      <Skeleton variant="rectangular" width={150} height={36} />
    </Box>
  );
};

export const GridItem = ({
  children,
  xs = 12,
  sm = 6,
  md = 4,
  lg = 4,
  ...props
}) => (
  <Grid
    item
    xs={xs}
    sm={sm}
    md={md}
    lg={lg}
    display="flex"
    flexDirection="column"
    {...props}
  >
    {children}
  </Grid>
);

export const FlexBox = (props) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    height="100%"
    width="100%"
    {...props}
  />
);

export const StyledSaveButton = (props) => (
  <Button variant="contained" color="primary" sx={{ width: 150 }} {...props} />
);
